export default "__VITE_ASSET__917a151c__"